<template>
  <div id="adminUtilizadores">
    <vue-headful title="Admin" lang="en" />

    <div v-if="criarAdmin">
      <div class="form-group">
        <label>Email</label>
        <input v-model="admin.email" type="email" class="form-control">
      </div>
      <div class="form-group">
        <label>Name</label>
        <input v-model="admin.driver_Name" type="email" class="form-control">
      </div>
      <div class="form-group">
        <label>Password</label>
        <input v-model="admin.password" type="password" class="form-control">
      </div>
      <div class="form-group">
        <label>Repeat Password</label>
        <input v-model="admin.new_password" type="password" class="form-control">
      </div>
      <button type="button" @click="submitAdmin" class="btn btn-primary float-right">SAVE</button>
    </div>
    <div v-else>
      <div v-if="form">
        <div v-if="form.role == 'driver'">
          <div class="form-group">
            <label>Client ID</label>
            <input disabled v-model="form.clientID" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Name</label>
            <input v-model="form.driver_Name" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Email</label>
            <input v-model="form.email" type="email" disabled class="form-control">
          </div>
          <div class="form-group">
            <label for="email_Notification">{{$store.state.option['conta_pessoal_user-email_Notification-' + lang]}}</label>
            <input id="email_Notification" v-model="form.email_Notification" type="checkbox">
          </div>
          <div class="form-group">
            <label>Address</label>
            <textarea v-model="form.address" class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label>Postal Code</label>
            <input v-model="form.postal_Code" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>City</label>
            <input v-model="form.city" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Country</label>
            <select id="country" class="form-control" v-model="form.country" style="height:50px;">
              <option value=""></option>
              <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Created At</label>
            <input disabled v-model="form.created_at" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Date Birth</label>
            <!--<input v-model="form.date_of_Birth" type="text" class="form-control">-->
            <date-picker v-model="form.date_of_Birth" :clearable="false" :editable="false" type="date"></date-picker>
          </div>
          <div class="form-group">
            <label>License Date</label>
            <!--<input v-model="form.license_Date" type="text" class="form-control">-->
            <date-picker v-model="form.license_Date" :clearable="false" :editable="false" type="date"></date-picker>
          </div>
          <div class="form-group">
            <label>License Number</label>
            <input v-model="form.license_Number" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>License Place</label>
            <input v-model="form.license_Place" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>License Country</label>
            <select id="license_Country" class="form-control" required="required" v-model="form.license_Country" style="height:50px;">
              <option value=""></option>
              <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
            </select>
          </div>

          <div class="form-group">
            <label>Document Type</label>
            <select id="document_Type" class="form-control" required="required" v-model="form.document_Type" style="height:50px;">
              <option value=""></option>
              <option value="0">Other</option>
              <option value="1">Ident Card</option>
              <option value="2">Passport</option>
            </select>
          </div>
          <div class="form-group">
            <label>Document Number</label>
            <input v-model="form.document_Number" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Document Date</label>
            <!--<input v-model="form.document_Date" type="date" class="form-control">-->
            <date-picker v-model="form.document_Date" :clearable="false" :editable="false" type="date"></date-picker>
          </div>
          <div class="form-group">
            <label>Document Place</label>
            <input v-model="form.document_Place" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>Mobile Phone</label>
            <input v-model="form.mobile_Number" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Phone</label>
            <input v-model="form.phone_Number" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Tax Number</label>
            <input v-model="form.tax_Number" type="number" class="form-control">
          </div>
        </div>

        <div v-if="form.role == 'client'">
          <div class="form-group">
            <label>Client ID</label>
            <input disabled v-model="form.clientID" type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Username</label>
            <input disabled v-model="form.username" type="text" class="form-control">
          </div>

          <div class="form-group">
            <label>Name</label>
            <input v-model="form.driver_Name" type="text" disabled class="form-control">
          </div>
          <div class="form-group">
            <label>Email</label>
            <input v-model="form.email" type="email" disabled class="form-control">
          </div>
          <div class="form-group">
            <label>Address</label>
            <textarea v-model="form.address" disabled class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label>Postal Code</label>
            <input v-model="form.postal_Code" disabled type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>City</label>
            <input v-model="form.city" disabled type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Country</label>
            <select id="country" disabled class="form-control" v-model="form.country" style="height:50px;">
              <option value=""></option>
              <option :value="dt.countryID" v-for="(dt,index) in $store.state.paises" :key="index">{{dt.country}}</option>
            </select>
          </div>

          <!--<div class="form-group">
            <label>Mobile Phone</label>
            <input v-model="form.mobile_Number" disabled type="text" class="form-control">
          </div>-->
          <div class="form-group">
            <label>Phone</label>
            <input v-model="form.Phone" disabled type="text" class="form-control">
          </div>
          <div class="form-group">
            <label>Observation</label>
            <textarea v-model="form.observations" disabled class="form-control"></textarea>
          </div>
          <div class="form-group">
            <label>Tax Number</label>
            <input v-model="form.tax_Number" disabled type="text" class="form-control">
          </div>
        </div>

        <div v-if="form.role == 'admin'">
          <div class="form-group">
            <label>Email</label>
            <input v-model="form.email" type="email" class="form-control">
          </div>
          <div class="form-group">
            <label>Driver Name</label>
            <input v-model="form.driver_Name" type="text" class="form-control">
          </div>

          <div class="clearfix"></div>
          <button type="button" @click="limpar()" class="btn btn-default float-left">CLOSE</button>
          <button type="button" @click="submit" class="btn btn-primary float-right">UPDATE</button>
          <div class="clearfix"></div>
          <h2 class="text-uppercase laranja" style="margin-top:30px;">Modify Password</h2>
          <hr style="margin-bottom: 30px;">
          <div>
            <div class="form-group">
              <label>Password</label>
              <input v-model="senha.password" type="password" class="form-control">
            </div>
            <div class="form-group">
              <label>New Password</label>
              <input v-model="senha.new_password" type="password" class="form-control">
            </div>
            <div class="form-group">
              <label>Repeat New Password</label>
              <input v-model="senha.new_password1" type="password" class="form-control">
            </div>
            <button type="button" @click="limpar()" class="btn btn-default float-left">CLOSE</button>
            <button type="button" @click="modSenha" class="btn btn-primary float-right">Update Password</button>
          </div>
        </div>

        <button v-if="form.role == 'driver' || form.role == 'client'" type="button" @click="limpar()" class="btn btn-default float-left">CLOSE</button>
        <button v-if="form.role == 'driver'" type="button" @click="submit" class="btn btn-primary float-right">UPDATE</button>
      </div>
      <div v-else>
        <h3>Search</h3>
        <div>
          <div class="form-group">
            <label for="driver_Name">Driver Name</label>
            <input type="text" v-model="search.driver_Name" id="driver_Name" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label for="email121">Email</label>
            <input type="text" v-model="search.email" id="email121" class="form-control" placeholder="">
          </div>
          <div class="form-group">
            <label for="role">Role</label>
            <select v-model="search.role" class="form-control" id="role">
              <option value=""></option>
              <option value="admin">Admin</option>
              <option value="driver">Driver</option>
              <option value="client">Client</option>
            </select>
          </div>
          <button @click="searchFN(1)" class="btn btn-primary float-right">Search</button>
        </div>
        <div class="clearfix"></div>
        <br />
        <hr />
        <br />
        <button class="btn btn-primary float-right" @click="createAdmin">Create Admin</button>
        <div class="table-responsive m-t-7">
          <table class="table table-bordered dataTable" id="dataTable" width="100%" cellspacing="0" role="grid" aria-describedby="dataTable_info">
            <thead>
              <tr role="row">
                <th>Type</th>
                <th>Name</th>
                <th>Email</th>
                <th style="width:48px;"></th>
              </tr>
            </thead>
            <tbody v-if="res[0]">
              <tr v-for="(dt, index) in res" :key="index">
                <td>{{dt.role}}</td>
                <td>{{dt.driver_Name}}</td>
                <td>{{dt.email}}</td>
                <td class="p-0 text-center">
                  <button class="btn btn-pure" @click="editar(dt, index)"><i class="fas fa-user-edit"></i></button>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <td colspan="4">
                <div class="alert alert-danger m-v-50" role="alert">You have no results to display.</div>
              </td>
            </tbody>
          </table>
        </div>
        <nav class="float-right">
          <ul class="pagination">
            <li class="page-item" v-if="pag > 1">
              <router-link class="page-link" to="1" @click="searchFN(1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </router-link>
            </li>
            <li v-if="pag - 2 > 1" class="page-item"><router-link class="page-link" :to="pag - 2" @click="searchFN(pag - 2)">{{pag - 2}}</router-link></li>
            <li v-if="pag - 1 > 1" class="page-item"><router-link class="page-link" :to="pag - 1" @click="searchFN(pag - 1)">{{pag - 1}}</router-link></li>
            <li class="page-item active"><a class="page-link">{{pag}}</a></li>
            <li v-if="parseInt(pag) + 1 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 1" @click="searchFN(parseInt(pag) + 1)">{{parseInt(pag) + 1}}</router-link></li>
            <li v-if="parseInt(pag) + 2 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 2" @click="searchFN(parseInt(pag) + 2)">{{parseInt(pag) + 2}}</router-link></li>
            <li v-if="parseInt(pag) + 3 < last_page" class="page-item"><router-link class="page-link" :to="parseInt(pag) + 3" @click="searchFN(parseInt(pag) + 3)">{{parseInt(pag) + 2}}</router-link></li>
            <li class="page-item" v-if="pag < last_page">
              <router-link class="page-link" :to="last_page" @click="searchFN(last_page)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'adminUtilizadores',
  data () {
    return {
      res: [],
      pag: 1,
      total: 0,
      last_page: 1,
      form: '',
      search: {
        driver_Name: '',
        role: '',
        email: '',
        tax_Number: ''
      },
      index: '',
      senha: {
        new_password: '',
        new_password1: '',
        password: ''
      },
      criarAdmin: false,
      admin: {
        new_password: '',
        password: '',
        driver_Name: '',
        email: ''
      }
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.SET_TITULO('Users')
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_TITULO',
      'SET_LOAD',
      'SET_TOAST',
      'SET_AVISO',
      'SET_LOAD1'
    ]),
    init () {
      if (this.$store.state.option1 && this.$store.state.paises1 && this.$store.state.user1) {
        if (!(this.$store.state.user.role)) {
          this.$router.push('/', () => {})
          return
        }
        this.SET_LOAD()
        this.searchFN(this.pag)
      } else {
        this._.delay(this.init, 100)
      }
    },
    searchFN (pag) {
      this.SET_LOAD1(true)
      let search = '?page=' + (pag || 1)
      if (this.search.role) {
        search += '&role=' + this.search.role
      }
      if (this.search.email) {
        search += '&email=' + this.search.email
      }
      if (this.search.driver_Name) {
        search += '&driver_Name=' + this.search.driver_Name
      }
      if (this.search.tax_Number) {
        search += '&tax_Number=' + this.search.tax_Number
      }
      this.axios.get('/backoffice/users/all' + search).then((res) => {
        this.criar = false
        this.total = res.data.total
        this.last_page = res.data.last_page
        this.res = res.data.data
        this.SET_LOAD1()
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    editar (dt, index) {
      this.index = index
      this.form = dt
      // res.data.created_at = new Date(res.data.created_at)
      this.form.date_of_Birth = new Date(this.form.date_of_Birth)
      this.form.license_Date = new Date(this.form.license_Date)
      this.form.document_Date = new Date(this.form.document_Date)
      this.SET_TITULO('EDIT USER - ' + dt.driver_Name)
      window.scrollTo(0, 0)
    },
    submit () {
      this.SET_LOAD1(true)
      this.axios.patch('/drivers', this.form).then((res) => {
        this.res[this.index] = this.form
        this.SET_TITULO('EDIT USER - ' + res.data.driver_Name)
        this.SET_TOAST({ msg: 'Updated successfully' })
      }, (er) => {
        this.SET_AVISO(er.response.data.error)
      })
    },
    limpar () {
      this.form = ''
      this.SET_TITULO('USERS')
      window.scrollTo(0, 0)
    },
    modSenha () {
      this.SET_LOAD1(true)
      if (this.senha.new_password === this.senha.new_password1 && this.senha.new_password.length) {
        this.axios.post('/users/change-password', this.senha).then((res) => {
          this.SET_TOAST({ msg: 'Updated successfully' })
        }, (er) => {
          this.SET_AVISO(er.response.data.status || er.response.data.error)
        })
      } else {
        this.SET_AVISO('Passwords don\'t match')
      }
    },
    submitAdmin () {
      this.SET_LOAD1(true)
      if (this.admin.new_password === this.admin.password && this.admin.new_password.length) {
        this.axios.post('/backoffice/add-admin', this.admin).then((res) => {
          this.SET_TOAST({ msg: 'Successfully Created' })
          this.criarAdmin = false
        }, (er) => {
          this.SET_AVISO(er.response.data.message)
        })
      } else {
        this.SET_AVISO('Passwords don\'t match')
      }
    },
    createAdmin () {
      this.criarAdmin = true
      this.admin = {
        new_password: '',
        password: '',
        driver_Name: '',
        email: ''
      }
    }
  }
}
</script>
